<script>
  export default {  
    name: "InfoButton",
    props: {
      minimized: {
        type: Boolean,
        default: false
      }
    },
    emits: ['showspecs'],
    data () {
      return {
        hasGlowingInfoBtn: false
      }
    },
    methods: {
      specsBtnMouseOver() {
        this.hasGlowingInfoBtn = true;
      },
      specsBtnMouseLeave(){
        this.hasGlowingInfoBtn = false;
      },
      emitShowSpecs() {
        this.$emit('showspecs');
      }
    }
  }
</script>
<template>
  <button 
    class="card-button-specs" 
    :style="minimized ? { top: '-8px', left: '8px', right: 'auto', borderRadius: '100%' } : {}"
    @mouseover="specsBtnMouseOver" 
    @mouseleave="specsBtnMouseLeave"
    @click.stop="emitShowSpecs()"
  >
    <Transition name="glow">
      <div 
        v-show="hasGlowingInfoBtn"
        class="absolutepos glowinginfo"
      />
    </Transition>
    <div 
      class="card-question-mark" 
      style="pointer-events: none;"
      :style="minimized ? { padding: '0px 6px' } : {}"
    >
      {{ minimized ? "i" : "?" }}
    </div>
    <div 
      v-if="!minimized" 
      class="card-button-specs-text"
    >
      Meer info
    </div>
  </button>
</template>
<style lang="scss" scoped>
.card {
  &-button-specs {
    position: absolute;
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-top: 16px;
    height: 23px;
    right: 0;
    top: -16px;
    padding: 3px;
    border-radius: $radius-l 0 0 $radius-l;
    border-style: none;
    background-color: $c-secondary;
    color: white;

    &-text {
      font-size: 0.7rem;
      padding: 0px 4px;
      font-family: 'Source Sans 3', sans-serif;
      font-weight: bold;
    }
  }

  &-question-mark {
    padding: 0px 5px;
    border-radius: $radius-l;
    font-weight: bold;
    font-size: 0.7rem;    
    color: white;
    background-color: $c-primary;
  }
}

.absolutepos {
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%;
}
.glowinginfo {
  background-color: rgba(255, 255, 255, 0.3);
}
</style>